



























































































































































































































































































































































































































































































import Vue from "vue";
import BaseModalWindow from "@/app/shared/components/base/BaseModalWindow.vue";
import BaseSearchInput from "@/app/shared/components/base/BaseSearchInput.vue";
import BaseButton from "@/app/shared/components/base/BaseButton.vue";
import BaseMediaTimeSlider from "@/app/shared/components/base/BaseMediaTimeSlider.vue";
import _ from "lodash";
import { $eventsBus } from "@/main";
import utils from "@/app/shared/utils/utils.js";
import { VTooltip } from "v-tooltip";

export default Vue.extend({
  name: "MusicLibraryWindow",
  components: {
    BaseModalWindow,
    BaseSearchInput,
    BaseButton,
    BaseMediaTimeSlider,
  },
  directives: {
    tooltip: VTooltip,
  },
  mixins: [utils],
  data: function () {
    return {
      filteredFiles: [],
      stockFilesRoasup: [],
      stockFilesPixabay: [],
      tab: "uploaded",
      playingFile: {
        currentTime: 0,
        file: null,
        libraryType: null,
        isNowPlaying: false,
      },
      chosenMusicFile: {
        file: null,
        libraryType: null,
      },
      isWasPlayingBeforeChanging: false,

      searchValue: "",

      stockRoasupCurrentSearchPage: 1,
      stockRoasupLimitSearchPage: 1,
      isStockRoasupWaitSearch: false,

      stockPixabayCurrentSearchPage: 1,
      stockPixabayLimitSearchPage: 1,
      isStockPixabayWaitSearch: false,

      isHideOnClickOutside: true,
    };
  },
  props: {
    isLoading: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    items: function () {
      return this.$store.state.items;
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
    userStockAccess: function () {
      return this.$store.state.userInfo.stockAccess;
    },
    isMainContentMuted: {
      // getter
      get: function () {
        return this.$store.state.muted;
      },
      // setter
      set: function (newValue) {
        this.$store.commit("muted", newValue);
      },
    },
    files: function () {
      return this.$store.getters.getFilesMusicLibrary;
    },
    recentMusicFiles: function () {
      return this.isLoading ? [] : this.$store.state.recentMusics;
    },
    filteredRecentMusicFiles: function () {
      return this.isLoading
        ? []
        : this.$store.state.recentMusics
            .filter((musicFile) => {
              const title =
                musicFile.libraryType === "uploaded"
                  ? musicFile.file.name
                  : musicFile.file.title;
              return (
                title
                  .toString()
                  .toLowerCase()
                  .split(".")
                  .slice(0, -1)
                  .join(".")
                  .indexOf(this.searchValue.toLowerCase()) !== -1
              );
            })
            .slice(0, 18);
    },
  },
  created() {},
  mounted() {
    $eventsBus.$emit("muteMainContent", true);
    if (!this.userStockAccess) {
      this.tab = "uploaded";
    } else {
      if (!!this.previewItem.currentVariation.music.file) {
        this.tab = !!this.previewItem.currentVariation.music.libraryType
          ? this.previewItem.currentVariation.music.libraryType
          : "uploaded";
      } else {
        this.tab = "uploaded";
      }
    }
    this.search(this.searchValue);
    this.chosenMusicFile = {
      file: this.previewItem?.currentVariation.music.file,
      libraryType: this.previewItem?.currentVariation.music.libraryType,
    };
  },
  watch: {
    tab: function () {
      if (this.tab === "stock-roasup") {
        const stockRoasup = this.$refs.stockRoasup;
        if (stockRoasup.onscroll) {
          return;
        }
        stockRoasup.onscroll = (e) => {
          if (
            stockRoasup.scrollTop + stockRoasup.clientHeight >=
            stockRoasup.scrollHeight
          ) {
            this.searchMoreStockRoasup();
          }
        };
      } else if (this.tab === "stock-pixabay") {
        const stockPixabay = this.$refs.stockPixabay;
        if (stockPixabay.onscroll) {
          return;
        }
        stockPixabay.onscroll = (e) => {
          if (
            stockPixabay.scrollTop + stockPixabay.clientHeight >=
            stockPixabay.scrollHeight
          ) {
            this.searchMoreStockPixabay();
          }
        };
      }
    },
    isLoading: function () {
      if (!this.isLoading) {
        this.searchInLibrary();
      }
    },
  },
  methods: {
    searchInLibrary() {
      if (this.searchValue === "") {
        this.filteredFiles = this.files;
      } else {
        this.filteredFiles = this.files.filter(
          (f) => f.name.toLowerCase().indexOf(this.searchValue) !== -1
        );
      }
    },
    search(value) {
      this.searchValue = value;
      this.searchInLibrary();

      this.stockFilesRoasup = [];
      this.stockRoasupCurrentSearchPage = 1;
      this.stockRoasupLimitSearchPage = 1;

      this.isStockRoasupWaitSearch = true;
      this.requestListStockRoasup();

      this.stockFilesPixabay = [];
      this.stockPixabayCurrentSearchPage = 1;
      this.stockPixabayLimitSearchPage = 1;

      this.isStockPixabayWaitSearch = true;
      this.requestListStockPixabay();
    },
    searchMoreStockRoasup() {
      console.log("try search more");
      if (
        this.stockRoasupCurrentSearchPage === this.stockRoasupLimitSearchPage ||
        this.isStockRoasupWaitSearch
      ) {
        return;
      }
      this.isStockRoasupWaitSearch = true;
      this.requestListStockRoasup();
    },
    requestListStockRoasup() {
      if (!this.userStockAccess) {
        this.isStockRoasupWaitSearch = false;
        return;
      }
      this.axios
        .post(
          "/utils/storyblocksList",
          {
            tag: this.searchValue,
            page: this.stockRoasupCurrentSearchPage,
            mode: "music",
            sessionId: this.$store.state.userInfo.sessionId,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (this.searchValue !== JSON.parse(response.config.data).tag) {
            return;
          }
          this.stockRoasupLimitSearchPage = response.data.limit;
          this.stockRoasupCurrentSearchPage =
            this.stockRoasupCurrentSearchPage ===
            this.stockRoasupLimitSearchPage
              ? this.stockRoasupLimitSearchPage
              : this.stockRoasupCurrentSearchPage + 1;
          response.data.list.forEach((file) => {
            this.stockFilesRoasup.push(file);
          });
          this.isStockRoasupWaitSearch = false;
        });
    },
    searchMoreStockPixabay() {
      console.log("try search more");
      if (
        this.stockPixabayCurrentSearchPage ===
          this.stockPixabayLimitSearchPage ||
        this.isStockPixabayWaitSearch
      ) {
        return;
      }
      this.isStockPixabayWaitSearch = true;
      this.requestListStockPixabay();
    },
    requestListStockPixabay() {
      this.axios
        .post(
          "/audio/getMusicPixabay",
          {
            search: this.searchValue,
            page: this.stockPixabayCurrentSearchPage,
            //"genre": "Cartoon",
            sessionId: this.$store.state.userInfo.sessionId,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (this.searchValue !== JSON.parse(response.config.data).search) {
            return;
          }
          this.stockPixabayLimitSearchPage = response.data.limit;
          this.stockPixabayCurrentSearchPage =
            this.stockPixabayCurrentSearchPage ===
            this.stockPixabayLimitSearchPage
              ? this.stockPixabayLimitSearchPage
              : this.stockPixabayCurrentSearchPage + 1;
          response.data.items.forEach((file) => {
            this.stockFilesPixabay.push(file);
          });
          this.isStockPixabayWaitSearch = false;
        });
    },
    changeCheckedItems() {
      if (!this.previewItem.currentVariation.checked) {
        return;
      }
      this.items.forEach((item) => {
        item.variations.forEach((v) => {
          if (!v.checked || v === this.previewItem.currentVariation) {
            return;
          }
          v.music.file = this.previewItem.currentVariation.music.file;
          v.music.libraryType = this.chosenMusicFile.libraryType
          v.checkAndUpdateMusicTime();
        });
      });
    },
    clearPlayingFile() {
      this.playPauseAudio(false, true);
      this.playingFile.file = null;
      this.playingFile.libraryType = null;
    },
    closeWindow() {
      $eventsBus.$emit("muteMainContent", false);
      this.$emit("close");
    },
    audioTimeChanged(e) {
      this.playingFile.currentTime = e.target.currentTime;
    },
    playPrevNextFile(isPrev) {
      let files = [];
      const libraryType = this.playingFile.libraryType;
      switch (this.playingFile.libraryType) {
        case "uploaded":
          files = this.filteredFiles;
          break;
        case "stock-roasup":
          files = this.stockFilesRoasup;
          break;
        case "stock-pixabay":
          files = this.stockFilesPixabay;
          break;
        default:
          break;
      }

      let currentIndex = files.indexOf(this.playingFile.file);
      if (currentIndex === -1 || (currentIndex !== -1 && files.length === 1)) {
        return;
      }
      let newIndex = isPrev
        ? currentIndex === 0
          ? files.length - 1
          : currentIndex - 1
        : currentIndex === files.length - 1
        ? 0
        : currentIndex + 1;
      this.playFile(libraryType, files[newIndex]);
    },
    playFile(type?, file?) {
      if (!file || file === this.playingFile.file) {
        if (this.playingFile.file) {
          this.playPauseAudio(!this.playingFile.isNowPlaying, false, false);
        }
        return;
      } else {
        if (this.playingFile.file) {
          this.playPauseAudio(false, true);
        }
        this.playingFile.file = file;
        this.playingFile.libraryType = type;
        this.playPauseAudio(true, false);
      }
    },
    getAudioElement(reload = true) {
      const audioRef = this.$refs.musicPlayer;
      if (reload) {
        !!audioRef && audioRef.load();
      }
      return audioRef;
    },
    playPauseAudio(isPlay, isResetTime, reload = true) {
      let audio = this.getAudioElement(reload);
      if (audio) {
        if (isResetTime) {
          audio.currentTime = 0;
        }
        isPlay ? audio.play() : audio.pause();
        this.playingFile.isNowPlaying = isPlay;
      }
    },
    onAddNewFile() {
      (<HTMLElement>this.$refs.fileInput).click();
    },
    onSelectTrack(type, file) {
      this.chosenMusicFile.file = file;
      this.chosenMusicFile.libraryType = type;
    },
    isMusicFileChosen(file) {
      return _.isEqual(file, this.chosenMusicFile?.file);
    },
    onLikeMusic(file) {
      this.isLoading = true;
      const config = {
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      };

      let route = "/utils/getStoryblocks";
      this.axios
        .post(
          route,
          { item: file, sessionId: this.$store.state.userInfo.sessionId },
          config
        )
        .then((res) => {
          this.$store.commit("unshiftFileToMusicLibrary", {
            duration: res.data.duration,
            path: res.data.file,
            id: res.data.fileId,
            name: res.data.name,
          });
          this.searchInLibrary();
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onDeleteMusic(file) {
      this.isHideOnClickOutside = false;
      $eventsBus.$emit("openConfirmWindow", {
        title: "Delete music file",
        message: "Are you sure to delete music?",
        acceptCallback: () => {
          this.deleteMusicFile(file);
          setTimeout(() => {
            this.isHideOnClickOutside = true;
          }, 200);
        },
        discardCallback: () => {
          setTimeout(() => {
            this.isHideOnClickOutside = true;
          }, 200);
        },
      });
    },
    deleteMusicFile(file) {
      const config = {
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      };

      let route = "/audio/remMusic";
      this.axios
        .post(
          route,
          { id: file.id, sessionId: this.$store.state.userInfo.sessionId },
          config
        )
        .then((res) => {
          if (this.playingFile.file == file) {
            this.clearPlayingFile();
          }
          if (this.isMusicFileChosen(file)) {
            //this.clearMusic();
          }
          this.$store.commit("deleteFileFromMusicLibrary", file);
          this.recentMusicFiles.forEach((recentMusicFile) => {
            if (
              recentMusicFile.libraryType === "uploaded" &&
              _.isEqual(recentMusicFile.file, file)
            ) {
              this.$store.commit("deleteRecentMusic", recentMusicFile);
            }
          });
          this.searchInLibrary();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onFileChanged(event: any) {
      let files: FileList = event.target.files;
      this.validateAndUploadFiles(files);
      event.target.value = "";
    },
    validateAndUploadFiles(files) {
      let result: File[] = [];
      const maxCount = 10;
      let maxIndex = files.length > maxCount ? maxCount : files.length;
      for (var i = 0; i < maxIndex; i++) {
        result.push(<File>files.item(i));
      }
      this.uploadFiles(result);
    },
    uploadFiles(files: File[]) {
      const config = {
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      };

      let data = new FormData();
      for (var i = 0; i < files.length; i++) {
        let file = files[i];
        data.append("files[" + i + "]", file);
      }
      data.append("sessionId", this.$store.state.userInfo.sessionId);

      let route = "/uploads/uploadMediaFiles";

      this.axios
        .post(route, data, config)
        .then((res) => {
          res.data.forEach((file) => {
            this.$store.commit("unshiftFileToMusicLibrary", {
              duration: file.duration,
              path: file.file,
              id: file.fileId,
              name: file.name,
            });
            this.searchInLibrary();
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    startChangeContentTime() {
      this.isWasPlayingBeforeChanging = this.playingFile.isNowPlaying;
      this.playPauseAudio(false, false, false);
    },
    changeContentTime(time) {
      let audio = this.getAudioElement(false);
      if (audio) {
        audio.currentTime = time;
        this.playingFile.currentTime = time;
      }
    },
    stopChangeContentTime() {
      if (this.isWasPlayingBeforeChanging) {
        this.playPauseAudio(true, false, false);
      }
    },
    checkAndUpdateRecentMusicFiles(libraryType, file) {
      const foundFileInRecent = this.recentMusicFiles.find(
        (recentMusicFile) => {
          return (
            recentMusicFile.libraryType === libraryType &&
            _.isEqual(recentMusicFile.file, file)
          );
        }
      );
      if (foundFileInRecent) {
        this.$store.commit("deleteRecentMusic", foundFileInRecent);
      }
      this.$store.commit("unshiftRecentMusic", {
        libraryType: libraryType,
        file: file,
      });
    },
    applyChanges() {
      if (!this.chosenMusicFile.file) {
        return;
      }
      this.previewItem.currentVariation.music.file = this.chosenMusicFile.file;
      this.previewItem.currentVariation.music.libraryType =
        this.chosenMusicFile.libraryType;
      this.checkAndUpdateRecentMusicFiles(
        this.chosenMusicFile.libraryType,
        this.chosenMusicFile.file
      );
      if (this.isMainContentMuted) {
        this.isMainContentMuted = false;
      }
      this.changeCheckedItems();
      this.closeWindow();
    },
  },
});
